import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { StrapiService } from '../../strapi/strapi.service';
import { HttpClient } from '@angular/common/http';
import { LanguageService, Language } from '../../language.service';

interface SpeciesInfo {
  sciname: string;
  gername?: string;
  engname?: string;
};

interface Species {
  sciname: string;
  name?: string;
};

@Component({
  selector: 'app-species-list',
  templateUrl: './species-list.component.html'
})
export class SpeciesListComponent implements OnInit {
  @Input() title?: string;
  species$: Observable<Species[]>;
  
  constructor(private languageService: LanguageService, private http: HttpClient) {}

  ngOnInit(): void {
    this.species$ = this.languageService.getLanguage().pipe(
      switchMap(language => 
        this.http.get<SpeciesInfo[]>('/api/imageidspecies').pipe(
          map( infos =>
            infos.map( info => {
              return { sciname: info.sciname, name: language != 'en' ? info.gername : info.engname};
            })
          )
        )
      )
    )
  }

  format(s: Species): string {
    if(s.name) {
      return `${s.sciname} (${s.name})`;
    } else {
      return `${s.sciname}`;
    }
  }
}
